
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io'; // <-- ¡Usa 'ngx-socket-io'!
import { Observable, Subject } from 'rxjs'; // Para manejar los streams de eventos

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  // Usa un Subject para emitir mensajes genéricos si lo necesitas
  private messageSource = new Subject<any>();
  message$ = this.messageSource.asObservable(); // Observable para que los componentes se suscriban

  constructor(private socket: Socket) {
    // Suscribirse a eventos de conexión/desconexión del Socket.IO
    this.socket.on('connect', () => {
      // console.log('Angular (Socket.IO): Conectado al servidor de Socket.IO con ID:', this.socket.ioSocket.id);
    });

    this.socket.on('disconnect', () => {
      // console.log('Angular (Socket.IO): Desconectado del servidor de Socket.IO');
    });

    this.socket.on('connect_error', (err: any) => {
      // console.error('Angular (Socket.IO): Error de conexión:', err.message);
    });

    // Puedes manejar aquí los eventos específicos que tu backend NestJS emite a nivel global
    // Por ejemplo, el evento 'message.contrato.estado'
    this.socket.on('message.contrato.estado', (data: any) => {
        this.messageSource.next({
            event: 'message.contrato.estado', // Puedes añadir el nombre del evento si es útil
            data: data
        });
    });

    // Si tienes otros eventos globales, puedes escucharlos aquí también
    // this.socket.on('otroEventoGlobal', (data: any) => { ... });
  }

  // --- Métodos para Emitir Eventos al Backend de Socket.IO ---

  // Para enviar mensajes genéricos o eventos personalizados
  sendMessage(event: string, payload: any): void {
    this.socket.emit(event, payload);
  }

  // Si tu backend tiene un evento 'joinRoom'
  joinRoom(room: string): void {
    this.socket.emit('joinRoom', room);
  }

  // Si tu backend tiene un evento 'msgToRoom'
  sendMessageToRoom(room: string, message: string): void {
    this.socket.emit('msgToRoom', { room, message });
  }

  // --- Métodos para Escuchar Eventos Específicos del Backend ---

  // Para escuchar cualquier evento que el backend emita
  listenForEvent(event: string): Observable<any> {
    return this.socket.fromEvent(event);
  }

  // Si quieres un Observable específico para el evento de contrato
  listenForContratoEstado(): Observable<any> {
    return this.listenForEvent('message.contrato.estado');
  }

  leaveRoom(room: string): void {
   this.socket.emit('leaveRoom', room);
  }

}